import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { ReturnUrlGuard } from 'src/app/core/guards/return-url.guard';
import { ResultPageComponent } from 'src/app/shared/components/result-page';

export const routes: Routes = [
  {
    path: 'result',
    component: ResultPageComponent,
    title: 'Result',
  },
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsModule),
  },
  {
    // added short alias to get shorter cleaner url when sharing stories
    path: 'story/:id',
    redirectTo: '/tabs/home/story/:id',
    pathMatch: 'full',
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignupModule),
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'new-ticket',
    loadChildren: () => import('./pages/contracts/new-ticket/new-ticket.module').then(m => m.NewTicketPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'renew-contract',
    loadChildren: () => import('./pages/contracts/renew-contract/renew-contract.module').then(m => m.RenewContractPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'hourly',
    loadChildren: () => import('./pages/hourly/hourly-routing.module').then(m => m.HourlyRoutingModule),
  },
  {
    path: 'monthly',
    loadChildren: () => import('./pages/monthly/monthly-routing.module').then(m => m.MonthlyRoutingModule),
  },
  {
    path: 'payment',
    loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentPageModule),
  },
  {
    path: 'addresses',
    loadChildren: () => import('./pages/addresses/addresses.module').then(m => m.AddressesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'business',
    loadChildren: () => import('./pages/business/business.module').then(m => m.BusinessPageModule),
  },
  {
    path: 'personal-info',
    loadChildren: () => import('./pages/profile/menu/personal-info/personal-info.module').then(m => m.PersonalInfoModule),
  },
  {
    path: 'my-tickets',
    loadChildren: () => import('./pages/profile/menu/my-tickets/my-tickets.module').then(m => m.MyTicketsModule),
  },
  {
    path: 'e-wallet',
    loadChildren: () => import('./pages/profile/menu/e-wallet/e-wallet.module').then(m => m.EWalletModule),
  },
  {
    path: 'payment-cards',
    loadChildren: () => import('./pages/profile/menu/payment-cards/payment-cards.module').then(m => m.PaymentCardsModule),
  },
  {
    path: 'faq',
    loadChildren: () => import('./pages/profile/menu/faq/faq.module').then(m => m.FaqModule),
  },
  {
    path: 'maharah-branches',
    loadChildren: () => import('./pages/profile/menu/maharah-branches/maharah-branches.module').then(m => m.MaharahBranchesModule),
  },
  {
    path: 'about-maharah',
    loadChildren: () => import('./pages/profile/menu/about-maharah/about-maharah.module').then(m => m.AboutMaharahModule),
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./pages/profile/menu/contact-us/contact-us.module').then(m => m.ContactUsModule),
  },
  {
    path: 'setting',
    loadChildren: () => import('./pages/profile/menu/setting/setting.module').then(m => m.SettingModule),
  },
  {
    path: 'hospitals',
    loadChildren: () => import('./pages/profile/menu/faq/hospitals/hospitals.module').then(m => m.HospitalsPageModule),
  },
  {
    path: 'mediation',
    loadChildren: () => import('./pages/home/mediation/mediation.module').then(m => m.MediationModule),
  },
  {
    path: 'ayadi-request',
    loadChildren: () => import('./pages/home/ayadi-request/ayadi-request.module').then(m => m.AyadiRequestModule),
  },
  {
    path: 'ayadi-request-form/:serviceId',
    loadChildren: () => import('./pages/home/ayadi-request/ayadi-request-form/ayadi-request-form.module').then(m => m.AyadiRequestFormModule),
  },
  {
    path: 'profile/delete',
    loadChildren: () => import('./pages/profile/delete/delete.module').then(m => m.DeleteModule),
  },
  {
    path: 'globcare-request',
    loadChildren: () => import('./pages/home/globcare/globcare-request.module').then(m => m.GlobcareRequestModule),
  },
  {
    path: 'globcare-request-form',
    loadChildren: () => import('./pages/home/globcare/globcare-request-form/globcare-request-form.module').then(m => m.GlobcareRequestFormModule),
  },
  {
    path: 'teknk',
    loadChildren: () => import('./pages/home/teknk/teknk.module').then(m => m.TeknkModule),
  },
  {
    path: '',
    loadChildren: () => import('./pages/splash/splash.module').then(m => m.SplashPageModule),
    canActivate: [ReturnUrlGuard],
  },
];
